module.exports = __webpack_public_path__ + "static/coming_soon-f7b18d5ac605b66c6c5939e37cf1c636.png";